const initialState = { 
  loading: false,
  success: null,
  error: null
}

function deleteProducerReducer(state = initialState, action) {
  switch (action.type) {
    case 'DELETE_PRODUCER_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'DELETE_PRODUCER_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'DELETE_PRODUCER_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default deleteProducerReducer